import { render, staticRenderFns } from "./GrupeVozila.vue?vue&type=template&id=77591bb4&"
import script from "./GrupeVozila.vue?vue&type=script&lang=ts&"
export * from "./GrupeVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports